module.exports = __webpack_public_path__ + "img/carlaguerrero.d287e1dc.jpg";